export const RELEASE_ROUTE = 'projects/:id/releases/:releaseId/:cbTabRouteId';
